<template>
  <div class="header">
    <div class="container">
      <b-navbar toggleable="lg" type="dark">
        <b-navbar-brand class="logo">
          <router-link to="/">
            <img src="../assets/logo.png" alt="logo" />
            <span>Business Debt Adjusters</span>
          </router-link>
        </b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav class="ml-auto">
            <b-nav-item to="/">Home</b-nav-item>
            <b-nav-item-dropdown text="About Us" right>
              <b-dropdown-item to="/whoWeAre">Who We Are</b-dropdown-item>
              <b-dropdown-item to="/whatWeOffer">What We Offer</b-dropdown-item>
            </b-nav-item-dropdown>
            <b-nav-item to="/faqs">FAQs</b-nav-item>
            <b-nav-item to="/ourTeam">Our Team</b-nav-item>
            <b-nav-item to="/blog">Blog</b-nav-item>
            <b-nav-item to="/contact">Contact Us</b-nav-item>
            <b-button variant="primary" v-b-modal.modal-center>Apply now</b-button>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>
    <b-modal id="modal-center" hide-footer centered title="Contact Form">
      <From />
    </b-modal>
    <back-to-top class="back_to_top" bottom="50px" right="40px">
      <button type="button" class="btn btn-primary btn-to-top">
        <b-icon icon="arrow-up"></b-icon>
      </button>
    </back-to-top>
    <b-button variant="primary" class="call_form" v-b-modal.modal-center>
      <b-icon icon="chat-dots-fill"></b-icon>
    </b-button>
  </div>
</template>

<script>
import From from "@/components/form";
export default {
  components: {
    From
  }
};
</script>

<style lang="scss" scoped>
.header {
  background: #343a40;
  padding: 10px 0;
  display: flex;
  align-items: center;
}

.nav-link {
  color: #fff;
}

.logo {
  img {
    width: 60px;
  }
  span {
    margin-left: 10px;
  }
  a {
    color: #fff;
    font-weight: 700;
    &:hover {
      text-decoration: none;
    }
  }
}
.modal-content {
  .modal-footer {
    display: none !important;
  }
}

.btn-to-top {
  width: 45px;
  height: 45px;
  padding: 6px 8px;
  border-radius: 50%;
  font-size: 22px;
  line-height: 22px;
}

.call_form {
  position: fixed;
  bottom: 45px;
  right: 110px;
  z-index: 20;
  border-radius: 50%;
  height: 55px;
  width: 55px;
  font-size: 22px;
}
.back_to_top {
  bottom: 50px;
  right: 50px;
}
@media (max-width: 767px) {
  .back_to_top {
    right: 85px!important;
  }
  .call_form {
    right: 20px;
  }
}

@media (max-width: 500px) {
  .logo {
    span {
      display: none;
    }
  }
}
</style>